module.exports = __webpack_public_path__ + "media/packs/images/flags/UY-bddc8baea4914db7ccbda01bf5b821a2.svg";